module.exports = __webpack_public_path__ + "img/3_02.953daa8d.jpg";